export const UNSTAKE_PAGE = 'UNSTAKE_PAGE';
export const STAKE_PAGE = 'STAKE_PAGE';
